import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, XCircle, Loader2 } from "lucide-react";
import { academy } from "@/lib/academy";
import { AcademyFrame } from "@/components/academy/AcademyFrame";

export default function AcademyVerifyPage() {
  const { code } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { academy.get(`/verify/${code}`).then((r) => setC(r.data)).catch(() => setC({ valid: false })); }, [code]);
  return (
    <AcademyFrame>
      <div className="mx-auto max-w-lg rounded-2xl border border-zinc-800/70 bg-[#111113] p-8 text-center" data-testid="academy-verify">
        {!c ? <Loader2 className="mx-auto animate-spin text-zinc-500" /> : c.valid ? (
          <>
            <BadgeCheck size={44} className="mx-auto text-emerald-400" />
            <h1 className="mt-3 text-2xl font-bold text-zinc-50" data-testid="academy-verify-status">Valid certificate</h1>
            <dl className="mt-6 space-y-2 text-left text-[14px]">
              {[["Certificate ID", c.id], ["Name", c.name], ["Course", c.course], ["Issued", new Date(c.issued_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })]].map(([k, v]) => (
                <div key={k} className="flex justify-between gap-4 border-b border-zinc-800/60 pb-2"><dt className="text-zinc-500">{k}</dt><dd className="text-right font-medium text-zinc-100" data-testid={`academy-verify-${k.toLowerCase().replace(" ", "-")}`}>{v}</dd></div>
              ))}
            </dl>
            <p className="mt-5 text-[12px] text-zinc-500">A certificate of completion, not accreditation. It is not a legal or professional qualification.</p>
          </>
        ) : (
          <>
            <XCircle size={44} className="mx-auto text-red-400" />
            <h1 className="mt-3 text-2xl font-bold text-zinc-50" data-testid="academy-verify-status">Certificate not found</h1>
            <p className="mt-2 text-[14px] text-zinc-400">No certificate exists with the ID {code}.</p>
          </>
        )}
      </div>
    </AcademyFrame>
  );
}
